// Stabila listor som inte hör hemma i databasen (UI-val).
export const PHONE_BRANDS = ["Apple", "Samsung", "Google", "Xiaomi", "Huawei", "Sony", "OnePlus", "Annan"];
export const OPERATORS = [
  "Chili Mobil",
  "Comviq",
  "Fello",
  "Fibio",
  "Halebop",
  "Hallon",
  "Lyca",
  "Tele2",
  "Telenor",
  "Telia",
  "Tre",
  "Vimla",
  "Ingen / Kontantkort",
  "Annan",
];
export const INTERESTS = [
  "Smartphone – tips & tricks",
  "Bild & videoredigering",
  "Säkerhet & backup",
  "Smart hem & uppkoppling",
  "Ljud & bild",
  "AI & nya teknologier",
  "Fotografering med mobil",
  "Annan fråga / förslag",
];
